import { NumberGroup } from "@ews/zlt-events";
import { ReactNode } from "react";

export type DisplayTabProps = {
    name: string,
    display: string,
    children: ReactNode;
};

export type SettingsOverlayProps = {
    systemId: string;
    onClose?: () => void;
};
export type Page = {
    value: string;
    title: string;
    child: React.ReactNode;
    show?: boolean;
};

export const T_GROUP_LIST: Partial<Record<NumberGroup, string>> = {
    [NumberGroup.Zone]: "[SID_GROUP_DEV_SHORT]",
    [NumberGroup.ActuationDevice]: "[SID_CONTR_DEV_SHORT]",
    [NumberGroup.TransmissionDevice]: "[SID_TRANS_DEV_SHORT]",
    [NumberGroup.AlarmingDevice]: "[SID_AL_DEV_SHORT]",
    [NumberGroup.FloodingZone]: "[SID_EXT_SEC_DEV_SH]"
};